import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AccountService } from '../_services/account.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private accountService: AccountService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        if ([401, 403].includes(err.status) &&
            !request.url.includes('/auth') &&
            !request.url.includes('/revoke-token')) {
          this.accountService.logout();
        }

        // Log the full error
        console.error('HTTP Error:', err);

        // Let the component handle the full HttpErrorResponse
        return throwError(err);// ✅ preserves err.error.message
      })
    );
  }
}
